import * as Config from 'effect/Config'

export const AppConfig = Config.all({
  apiUrl: Config.string(`VITE_API_URL`),
})
